import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { Card } from '@material-ui/core';
import TableWithPagination from '../Table/TableWithPagination';
import { downloadInvoice, invoiceIsDue, setFilteredAndSortedInvoices } from '../../redux/invoices/invoicesActions'
import { connect } from 'react-redux';
import { MODULE_EXTRANET_INVOICES } from '../../redux/authorizedApps/authorizedAppsConstants';

class InvoicesAsTable extends Component {

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: this.downloadInvoice.bind(this, rowInfo.row._original),
                style: {
                    cursor: 'pointer',
                    // backgroundColor: invoiceIsDue(rowInfo.row._original) ? "#F44336" : "",
                    // color: invoiceIsDue(rowInfo.row._original) ? "#F5F6F5" : ""
                },
            }
        } else {
            return {}
        }
    }

    downloadInvoice(invoice) {
        this.props.downloadInvoice(invoice, this.props.activeUser);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return <Card>
            <TableWithPagination
                data={this.props.filteredAndSortedInvoices.filter((a) => !a.deleted)}
                pages={Math.ceil(this.props.tableState.nbTotalResults[MODULE_EXTRANET_INVOICES] / this.props.tableState.pageSize)}
                getTrProps={this.getTableTrProps.bind(this)} manual columns={this.props.columns}
                onFetchData={(state) => {
                    let tableState = {
                        pageSize: state.pageSize,
                        pageNumber: state.page,
                        orderBy: state.sorted.length > 0 ? state.sorted[0].id : "",
                        descOrder: state.sorted.length > 0 ? state.sorted[0].desc : false
                    }

                    this.props.setFilteredAndSortedInvoices(this.props.invoices, this.props.affair, this.props.intervention,
                        tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
                }}
            />
        </Card>
    }
}

const mapStateToProps = (state) => {
    return {
        invoices: state.invoices,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedInvoices: (invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedInvoices(invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults)),
        downloadInvoice: (invoice, user) => dispatch(downloadInvoice(invoice, user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesAsTable);
